import i18n from '@/lib/i18n'

export const NOTIFICATION_MESSAGE = {
  AUTH: {
    UPDATE_PASSWORD: i18n.t('auth.password.updated'),
  },
  FAVORITE: {
    CREATE: i18n.t('favorite.list.action.message.create'),
    UPDATE_SETTING: i18n.t('favorite.list.action.message.updateSetting'),
    DELETE: i18n.t('favorite.list.action.message.delete'),
    COPY: i18n.t('favorite.list.action.message.copy'),
    SORT: i18n.t('favorite.list.action.message.sort'),
  },
  FAVORITE_ITEMS: {
    SORT: i18n.t('favorite.item.action.message.sort'),
    COPY: i18n.t('favorite.item.action.message.copy'),
    MOVE: i18n.t('favorite.item.action.message.move'),
    DELETE: i18n.t('favorite.item.action.message.delete'),
    ADD_CART: i18n.t('favorite.item.action.message.addCart'),
  },
  CART: {
    UPDATE_SHIPPING_INFO: i18n.t('cart.shipping.message.update'),
    UPDATE_DELIVERY_DATE: i18n.t('cart.date.message.update'),
    CLEAR: i18n.t('cart.item.action.message.clear'),
    REMOVE_ITEM: i18n.t('cart.item.action.message.remove'),
    OVER_DISIRED_DERIVERY_DATE: i18n.t(
      'cart.shipping.message.overDesiredDeliveryDate'
    ),
  },
  USER: {
    UPDATE_EMAIL_SUBSCRIPTION: i18n.t(
      'user.email.receiveSettings.changeSuccess'
    ),
  },
  ORDER: {
    APPROVE: i18n.t('order.action.message.approve'),
    BULK_APPROVE: i18n.t('order.action.message.bulkApprove'),
    REVOKE_APPROVE: i18n.t('order.action.message.revokeApprove'),
    BULK_REVOKE_APPROVE: i18n.t('order.action.message.bulkRevokeApprove'),
    CANCEL: i18n.t('order.action.message.cancel'),
    BULK_CANCEL: i18n.t('order.action.message.bulkCancel'),
    RETURN_TO_CART: i18n.t('order.action.message.returnToCart'),
    UPDATE_DELIVERY_DATE: i18n.t('order.action.message.updateDeliveryDate'),
    UPDATE_SHIPPING_INFO: i18n.t('order.action.message.updateShippingInfo'),
    UPDATE_DELIVERY_DATE_FAILED: i18n.t(
      'order.action.message.failedUpdateDeliveryDate'
    ),
    UPDATE_SHIPPING_INFO_FAILED: i18n.t(
      'order.action.message.failedUpdateShippingInfo'
    ),
    UPDATE_ITEM_FAILED: (orderNo: string) =>
      i18n.t('order.action.message.failedUpdateItem', { orderNumber: orderNo }),
    BULK_CANCEL_FAILED: (orderNos: string[]) =>
      i18n.t('order.action.message.failedBulkCancel', {
        orderNumbers: orderNos.join(','),
      }),
  },
  ORDER_IMPORT: {
    DETAIL_FAILED_TITLE: i18n.t('order.import.search.message.failedToFetch'),
    DOWNLOAD_FAILED_TITLE: i18n.t(
      'order.import.search.message.failedToDownload'
    ),
  },
  PURCHASED_INFO: {
    DOWNLOAD_FAILED_TITLE: i18n.t('purchasedInfo.common.failedToDownload'),
  },
  DOWNLOAD: {
    DOWNLOAD_FAILED_TITLE: i18n.t('purchasedInfo.common.failedToDownload'),
  },
}
